// eslint-disable-next-line no-unused-vars
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isTokenValid } from "../utils/tokenUtils";
import safeLogger from "../utils/safeLogger";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const profile = localStorage.getItem("profile");

  useEffect(() => {
    if (!token || !isTokenValid(token)) {
      safeLogger.warn("Token inválido ou ausente. Redirecionando para login.");
      navigate("/login", {
        state: {
          from: location.pathname,
          expired: true,
          email: localStorage.getItem("email") || null,
        },
      });
    } else if (allowedRoles.length > 0 && !allowedRoles.includes(profile)) {
      safeLogger.warn("Perfil não autorizado. Redirecionando para login.");
      navigate("/login", {
        state: { from: location.pathname, unauthorized: true, email: localStorage.getItem("email") || null },
      });
    }
  }, [navigate, location, token, profile, allowedRoles]);

  return children;
};

export default ProtectedRoute;
